import { DATE_PUBLISHED } from 'Pods/SearchPage/Store/constants'

export const datePublishedFiltersConfig = [{
  label: null,
  filters: [
    { value: DATE_PUBLISHED.ALL_TIME, labelKey: 'all_time' },
    { value: DATE_PUBLISHED.LAST_24_HOURS, labelKey: 'last_24_hours' },
    { value: DATE_PUBLISHED.LAST_7_DAYS, labelKey: 'last_7_days' },
    { value: DATE_PUBLISHED.LAST_30_DAYS, labelKey: 'last_month' },
    { value: DATE_PUBLISHED.LAST_3_MONTHS, labelKey: 'last_3_months' },
    { value: DATE_PUBLISHED.LAST_6_MONTHS, labelKey: 'last_6_months' },
    { value: DATE_PUBLISHED.LAST_12_MONTHS, labelKey: 'last_year' },
  ],
}]
